// Api related configuration

// ---- Api related configuration values
export const api = {
    initial_domain: process.env.REACT_APP_API_URL,
    domain: process.env.REACT_APP_API_URL + "/",
    routes: {
        // Authentication
        logUser: "auth/jwt_login",
        refreshToken: "auth/refresh_token",
        // Grade
        grades: "grades",
        flashGrades: "grades/flash",
        // Image
        proxyImage: "proxyMinio",
        // Knowledge
        knowledgesForGrade: "knowledges/:id",
        // LegalContent
        legalContent: "legalContent/:key",
        // Level A
        exam: "levelAs/exam",
        singleProblem: "levelA/problem/:identifier",
        exerciserProblem: "levelA/exerciser/:identifier",
        // Questions
        singleQuestion: "question/:id",
        leveledQuestions: "questions/:id",
        questionsFromLevelAsIds: 'questions',
        // Subtheme
        subthemesWithLevelAsForGrade: "subthemes/levelAs/:id",
        subthemesWithLevelAsForGradeAndTheme: "subthemes/levelAs",
        // Terms
        terms: "terms",
        // Theme
        themes: "themes",
    }
}